import JSONAPISerializer from "@ember-data/serializer/json-api";

export type SerializedPayload = {
  data: {
    attributes: Record<string, string>;
    relationships?: Record<string, string>;
  };
};

export default class extends JSONAPISerializer {
  serialize(snapshot, options) {
    const payload = super.serialize(snapshot, options) as SerializedPayload;

    if (snapshot.modelName.endsWith("-journal-event")) {
      if (payload.data?.attributes) {
        // The API returns the createdAt, but this is only a readonly attribute
        delete payload.data.attributes["created-at"];
        delete payload.data.attributes["updated-at"];
      }
    }

    return payload;
  }
}
